import { predict2D } from './utils/predict2D';
/**
 * Generate the correlation bidimensional nmr peaks based on the number of bonds between a pair of atoms
 * @returns {Promise<object>} - object with molfile, diaIDs, 2D signals joined signals and zones.
 */
export async function predictHSQC(molecule, options) {
    const { minLength = 1, maxLength = 1, joinDistance = { H: 0.05, C: 0.5 }, } = options;
    return predict2D(molecule, {
        ...options,
        from: 'H',
        to: 'C',
        minLength,
        maxLength,
        joinDistance,
    });
}
//# sourceMappingURL=predictHSQC.js.map